module.exports = __webpack_public_path__ + "img/wallet-icon.69be438b.svg";